import * as React from 'react';
import {
	ContentWrapper,
	Image,
	ImageWrapper,
	TitleWrapper,
	ValuePropsItemWrapper,
} from './ValuePropStyles';
import {language} from '../../ValuePropsSectionLanguage'
import {ValuePropType} from "../../../../../../Types/Homepage/ValuePropType";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export type Props = {
	valueProp: ValuePropType
};

export const ValueProp = (props: Props) =>
{
	const render = () =>
	{
		let iconOrImage = null;
		if (props.valueProp.icon)
			iconOrImage = <FontAwesomeIcon icon={props.valueProp.icon} />;
		else if (props.valueProp.image)
			iconOrImage = <Image src={props.valueProp.image} />;

		const returnValue = (
			<ValuePropsItemWrapper>
				<ImageWrapper>
					{iconOrImage}
				</ImageWrapper>
				<TitleWrapper>
					{props.valueProp.title}
				</TitleWrapper>
				<ContentWrapper>
					{props.valueProp.content}
				</ContentWrapper>
			</ValuePropsItemWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
